export const customerAddress = {
  api: 'customerEndpoint/address',
  validate: 'locationEndpoint/validateAddress',
  validateAddress: 'locationEndpoint/v2/validateAddress',
  selectDefault: 'customerAddressEndpoint/address/:idAddress/default',
};
